/**
 * Tab `stock-sales` của `MatchingContractOverviewPage` — render StockSalesPage
 * (Allocating Stock → Sales, mirror Access frmMatchingPSMatch_Stock_Sales).
 */
import StockSalesPage from './stockSales/StockSalesPage'

export default function StockSalesTab() {
  return <StockSalesPage />
}
